import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrouillonsComponent } from './brouillons.component';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [BrouillonsComponent],
  imports: [
    CommonModule,
    PanelModule,
    TableModule,
    FormsModule,
    ButtonModule,
    MultiSelectModule
  ]
})
export class BrouillonsModule { }
